"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var semantic_ui_react_1 = require("semantic-ui-react");
var lodash_1 = __importDefault(require("lodash"));
var classnames_1 = __importDefault(require("classnames"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var BlMultiDropdown = function (_a) {
    var placeholder = _a.placeholder, options = _a.options, value = _a.value, onChange = _a.onChange, className = _a.className;
    var toggleSelection = function (checked, v) {
        if (checked) {
            onChange(__spreadArray(__spreadArray([], value), [v]));
        }
        else {
            onChange(value.filter(function (el) { return el !== v; }));
        }
    };
    var isChecked = function (v) {
        return lodash_1.default.includes(value, v);
    };
    var textByValues = function () {
        if (!value.length) {
            return placeholder;
        }
        return options
            .filter(function (o) {
            return lodash_1.default.includes(value, o.value);
        })
            .map(function (o) { return o.text; })
            .join(', ');
    };
    return (react_1.default.createElement(semantic_ui_react_1.Dropdown, { className: classnames_1.default('selection', styles_module_scss_1.default.dropdown, className), item: true, fluid: true, text: textByValues(), multiple: true, additionPosition: "bottom", placeholder: placeholder },
        react_1.default.createElement(semantic_ui_react_1.Dropdown.Menu, null, options.map(function (_a, index) {
            var value = _a.value, text = _a.text, count = _a.count;
            return (react_1.default.createElement(semantic_ui_react_1.Dropdown.Item, { key: index, className: classnames_1.default(isChecked(value) && styles_module_scss_1.default.checked), onClick: function (e) { return e.stopPropagation(); } },
                react_1.default.createElement(semantic_ui_react_1.Checkbox, { checked: isChecked(value), label: react_1.default.createElement("div", { className: "dropdown_item" },
                        react_1.default.createElement("div", null, text),
                        lodash_1.default.isArray(count) && (react_1.default.createElement("div", { className: value },
                            "(",
                            count.length,
                            ")"))), onChange: function (e, data) {
                        toggleSelection(data.checked, value);
                    } })));
        }))));
};
exports.default = BlMultiDropdown;
